import { Card, Badge } from '@/core/ui/components';
import type { TenantDashboardBilling } from '@yawi/types';
import { formatCurrency } from '@yawi/infrastructure';
import { DollarSign, TrendingUp, FileText } from 'lucide-react';

interface BillingCardProps {
  billing: TenantDashboardBilling | null;
}

export function BillingCard({ billing }: BillingCardProps) {
  if (!billing) {
    return (
      <Card>
        <h3 className="text-lg font-semibold text-theme mb-4 flex items-center gap-2">
          <DollarSign className="w-5 h-5" />
          Facturación
        </h3>
        <p className="text-theme-secondary text-center py-4">
          Sin datos de facturación disponibles
        </p>
      </Card>
    );
  }

  return (
    <Card>
      <h3 className="text-lg font-semibold text-theme mb-4 flex items-center gap-2">
        <DollarSign className="w-5 h-5" />
        Facturación
      </h3>

      <dl className="space-y-4">
        <div className="flex justify-between items-center">
          <dt className="text-theme-secondary flex items-center gap-2">
            <TrendingUp className="w-4 h-4" />
            Ingresos totales
          </dt>
          <dd className="text-theme font-semibold text-lg">
            {formatCurrency(billing.totalRevenue)}
          </dd>
        </div>

        <div className="flex justify-between items-center">
          <dt className="text-theme-secondary">Ingresos este mes</dt>
          <dd className="text-theme font-medium">
            {formatCurrency(billing.currentMonthRevenue)}
          </dd>
        </div>

        <div className="flex justify-between items-center">
          <dt className="text-theme-secondary flex items-center gap-2">
            <FileText className="w-4 h-4" />
            Facturas
          </dt>
          <dd>
            <Badge variant={billing.invoices.length > 0 ? 'default' : 'warning'}>
              {billing.invoices.length} factura{billing.invoices.length !== 1 ? 's' : ''}
            </Badge>
          </dd>
        </div>

        <div className="flex justify-between items-center">
          <dt className="text-theme-secondary">Métodos de pago</dt>
          <dd>
            <Badge variant={billing.paymentMethods.length > 0 ? 'success' : 'warning'}>
              {billing.paymentMethods.length} configurado{billing.paymentMethods.length !== 1 ? 's' : ''}
            </Badge>
          </dd>
        </div>
      </dl>
    </Card>
  );
}
